(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ohara-contact-context]').forEach(container => {
    const params = new URLSearchParams(window.location.search);
    const fields = {
      product: '[data-contact-product]',
      variant: '[data-contact-variant]',
      product_url: '[data-contact-product-url]'
    };

    Object.entries(fields).forEach(([parameter, selector]) => {
      const field = container.querySelector(selector);
      const value = params.get(parameter);
      if (field && value) field.value = value;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
